<template>
  <div>
    <v-card class="mt-4" shaped>
      <v-container v-if="selectedCase">
        <v-row>
          <v-col cols="12" md="4">
            <CardAlert :color="getThemeColor">
              <ForeignKeyField
                class="mb-n10"
                :label="getCompanyLabels.client"
                :foreignFieldValue="selectedClient"
                table="clients"
                @field-selected="selectedClientField"
              ></ForeignKeyField
            ></CardAlert>
          </v-col>

          <v-col cols="12" md="4"
            ><CardAlert :color="getThemeColor">
              <v-text-field
                class="mb-n10"
                v-model="selectedCase.title"
                label="Title"
                @change="
                  updateField(
                    'cases',
                    'title',
                    selectedCase.id,
                    selectedCase.title
                  )
                "
              ></v-text-field
            ></CardAlert>
          </v-col>

          <v-col cols="12" md="4">
            <CardAlert :color="getThemeColor">
              <v-text-field
                class="mb-n10"
                v-model="selectedCase.file_number"
                :label="getCompanyLabels.matter + ' Number'"
                @change="
                  updateField(
                    'cases',
                    'file_number',
                    selectedCase.id,
                    selectedCase.file_number
                  )
                "
              ></v-text-field
            ></CardAlert>
          </v-col>
        </v-row>
      </v-container>

      <v-container v-if="selectedCase">
        <v-row>
          <v-col cols="12" md="4">
            <CardAlert :color="getThemeColor">
              <v-text-field
                class="mb-n10"
                v-model="selectedCase.petitioners"
                label="Applicant(s)"
                @change="
                  updateField(
                    'cases',
                    'petitioners',
                    selectedCase.id,
                    selectedCase.petitioners
                  )
                "
              ></v-text-field
            ></CardAlert>
          </v-col>

          <v-col cols="12" md="4">
            <CardAlert :color="getThemeColor">
              <v-text-field
                class="mb-n10"
                v-model="selectedCase.respondents"
                label="Respondent(s)"
                @change="
                  updateField(
                    'cases',
                    'respondents',
                    selectedCase.id,
                    selectedCase.respondents
                  )
                "
              ></v-text-field
            ></CardAlert>
          </v-col>

          <v-col cols="12" md="4">
            <CardAlert :color="getThemeColor">
              <v-text-field
                class="mb-n10"
                v-model="selectedCase.presiding_officer"
                label="Presiding Officer"
                @change="
                  updateField(
                    'cases',
                    'presiding_officer',
                    selectedCase.id,
                    selectedCase.presiding_officer
                  )
                "
              ></v-text-field
            ></CardAlert>
          </v-col>
        </v-row>
      </v-container>

      <v-container v-if="selectedCase">
        <v-row>
          <!-- <v-col cols="12" md="3">
            <CardAlert :color="getThemeColor">
              <DatePickerWithMenu
                class="mb-n10"
                :default="dateCaptured"
                label="Date Captured"
                @date-selected="getDateCaptured"
              ></DatePickerWithMenu
            ></CardAlert>
          </v-col> -->

          <v-col cols="12" md="4">
            <CardAlert :color="getThemeColor">
              <DatePickerWithMenu
                class="mb-n15"
                :default="selectedCase.start_date"
                label="Start Date"
                @date-selected="getDateStart"
              ></DatePickerWithMenu
            ></CardAlert>
          </v-col>

          <v-col cols="12" md="4">
            <CardAlert :color="getThemeColor">
              <DatePickerWithMenu
                class="mb-n15"
                :default="selectedCase.end_date"
                label="End Date"
                @date-selected="getDateEnd"
              ></DatePickerWithMenu
            ></CardAlert>
          </v-col>

          <v-col cols="12" md="4">
            <CardAlert :color="getThemeColor">
              <ForeignKeyField
                class="mb-n10"
                label="Court Type"
                :foreignFieldValue="selectedCourtType"
                table="court_types"
                @field-selected="selectedCourtTypeField"
              ></ForeignKeyField>
            </CardAlert>
          </v-col>
        </v-row>
      </v-container>

      <v-container v-if="selectedCase">
        <v-row>
          <v-col cols="12" md="4">
            <CardAlert :color="getThemeColor">
              <ForeignKeyField
                class="mb-n10"
                :label="getCompanyLabels.matter + ' Scale'"
                :foreignFieldValue="selectedScaleValue"
                table="scales"
                @field-selected="selectedScaleField"
              ></ForeignKeyField>
            </CardAlert>
          </v-col>

          <v-col cols="12" md="4">
            <CardAlert :color="getThemeColor">
              <ForeignKeyField
                class="mb-n10"
                label="Attorney Type"
                :foreignFieldValue="selectedAttorneyType"
                table="attorney_types"
                @field-selected="selectedAttorneyTypeField"
              ></ForeignKeyField>
            </CardAlert>
          </v-col>

          <v-col cols="12" md="4">
            <CardAlert :color="getThemeColor">
              <ForeignKeyField
                class="mb-n10"
                label="Status"
                :foreignFieldValue="caseStatus"
                table="case_statuses"
                @field-selected="caseStatusFieldSelected"
              ></ForeignKeyField
            ></CardAlert>
          </v-col>
        </v-row>
      </v-container>

      <v-container v-if="selectedCase">
        <v-row>
          <v-col cols="12" md="4">
            <CardAlert :color="getThemeColor">
              <v-textarea
                rows="3"
                class="mb-n10"
                :label="getCompanyLabels.matter + ' Description'"
                :value="selectedCase.description"
                @focusout="getTextAreaContent('description')"
              ></v-textarea
            ></CardAlert>
          </v-col>

          <v-col cols="12" md="4">
            <CardAlert :color="getThemeColor">
              <v-textarea
                rows="3"
                class="mb-n10"
                label="Notes"
                :value="selectedCase.notes"
                @focusout="getTextAreaContent('notes')"
              ></v-textarea
            ></CardAlert>
          </v-col>

          <v-col cols="12" md="4">
            <CardAlert :color="getThemeColor">
              <v-textarea
                rows="3"
                class="mb-n10"
                label="Outcome"
                :value="selectedCase.outcome"
                @focusout="getTextAreaContent('outcome')"
              ></v-textarea>
            </CardAlert>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import DatePickerWithMenu from "@/components/myLibrary/DatePickerWithMenu.vue";
import ForeignKeyField from "@/components/General/ForeignKeyField.vue";
import CardAlert from "@/components/myLibrary/CardAlert.vue";

export default {
  props: ["selCase"],
  mounted() {
    this.selectedCase = this.selCase;
    this.refreshData(this.selCase);
  },
  computed: {
    getCompanyLabels() {
      return this.$store.getters.getCompanyLabels;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
  },
  watch: {
    selCase(newVal) {
      this.refreshData(newVal);
      this.selectedCase = newVal;
    },
  },
  components: {
    DatePickerWithMenu,
    ForeignKeyField,
    CardAlert,
  },
  data: () => ({
    selectedCase: null,
    caseStatus: null,
    caseStatusID: null,
    selectedCourt: null,
    selectedCourtID: null,
    selectedCourtType: null,
    selectedCourtTypeID: null,
    selectedAttorneyTypeID: null,
    selectedScaleID: null,
    selectedScaleValue: null,
    selectedAttorneyType: null,
    selectedClientID: null,
    selectedClient: null,
    description: null,
    notes: null,
    outcome: null,
    dateCaptured: new Date().toISOString().substr(0, 10),
  }),
  methods: {
    refreshData(selectedCase) {
      this.selectedClient = selectedCase.client.name;
      this.selectedClientID = selectedCase.client.client_reference;

      if (selectedCase.status) {
        this.caseStatusID = selectedCase.status.id;
        this.caseStatus = selectedCase.status.name;
      }

      if (selectedCase.attorney) {
        this.selectedAttorneyTypeID = selectedCase.attorney.id;
        this.selectedAttorneyType = selectedCase.attorney.name;
      }

      if (selectedCase.court_type) {
        this.selectedCourtTypeID = selectedCase.court_type.id;
        this.selectedCourtType = selectedCase.court_type.name;
      }

      if (selectedCase.scale) {
        this.selectedScaleID = selectedCase.scale.id;
        this.selectedScaleValue = selectedCase.scale.name;
      }
    },
    getTextAreaContent(column) {
      switch (column) {
        case "description":
          this.selectedCase.description = event.target.value;
          this.updateField(
            "cases",
            "description",
            this.selectedCase.id,
            event.target.value
          );
          break;
        case "notes":
          this.selectedCase.notes = event.target.value;
          this.updateField(
            "cases",
            "notes",
            this.selectedCase.id,
            event.target.value
          );
          break;
        case "outcome":
          this.selectedCase.outcome = event.target.value;
          this.updateField(
            "cases",
            "outcome",
            this.selectedCase.id,
            event.target.value
          );
          break;
      }
    },
    updateField(table, column, id, value) {
      axios
        .postDataWithToken(
          "/auth/update-item",
          { table, column, id, value },
          this.getAccessToken
        )
        .then((response) => {
          this.$emit("refresh-needed", response.id);
        });
    },
    selectedClientField(vals) {
      this.selectedClientID = vals[0];
      this.selectedCase.selectedClientID = vals[0];
      this.selectedClient = vals[1];
    },
    getDateCaptured(dateCaptured) {
      this.selectedCase.dateCaptured = dateCaptured;
      this.updateField(
        "cases",
        "date_captured",
        this.selectedCase.id,
        dateCaptured
      );
    },
    getDateStart(dateStart) {
      this.selectedCase.dateStart = dateStart;
      this.updateField("cases", "start_date", this.selectedCase.id, dateStart);
    },
    getDateEnd(dateEnd) {
      this.selectedCase.dateEnd = dateEnd;
      this.updateField("cases", "end_date", this.selectedCase.id, dateEnd);
    },
    caseStatusFieldSelected(vals) {
      this.caseStatusID = vals[0];
      this.selectedCase.caseStatusID = vals[0];
      this.caseStatus = vals[1];
      this.updateField(
        "cases",
        "case_status_id",
        this.selectedCase.id,
        vals[0]
      );
    },
    selectedAttorneyTypeField(vals) {
      this.selectedAttorneyTypeID = vals[0];
      this.selectedCase.selectedAttorneyTypeID = vals[0];
      this.selectedAttorneyType = vals[1];
      this.updateField(
        "cases",
        "attorney_type_id",
        this.selectedCase.id,
        vals[0]
      );
    },
    selectedCourtTypeField(vals) {
      this.selectedCourtTypeID = vals[0];
      this.selectedCase.selectedCourtTypeID = vals[0];
      this.selectedCourtType = vals[1];
      this.updateField("cases", "court_type_id", this.selectedCase.id, vals[0]);
    },
    selectedScaleField(vals) {
      this.selectedScaleID = vals[0];
      this.selectedCase.selectedScaleID = vals[0];
      this.selectedScaleValue = vals[1];
      this.updateField("cases", "scale_id", this.selectedCase.id, vals[0]);
    },
  },
};
</script>

<style></style>
